module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_004_sm-b4025c4a.png";